<template>
  <div class="overflow-hidden">
    <div class="min-h-screen">
      <!-- Main Section -->
      <div class="py-16 px-4 sm:px-6 lg:pl-16 lg:pr-4 flex flex-col md:flex-row" ref="observerElement">
        <!-- Left Section with Main Image and Text -->
        <div class="w-full md:w-2/3 mb-4 md:mb-0 px-4">
          <transition name="fade-slide-up" appear v-if="isVisible">
            <img src="../assets/Hanga-24/home/inno-section-2.jpg" alt="Students" class="w-full h-auto"
              ref="leftContent">
          </transition>

          <transition name="fade-slide-up" appear v-if="isVisible">
            <div>
              <p class="font-gramatika mt-12 text-darknavy text-lg sm:text-xl" ref="text1">
                Celebrating 6 years as the largest in-person technology event in Rwanda,
                Hanga Pitchfest continues to ignite & inspire innovation.</p>
              <router-link to="/pitch">
                <button
                  class="bg-tangerine  mt-10 text-white  font-gramatika text-md sm:text-xl py-3 sm:py-4 px-8 sm:px-12 hover:bg-orange-500 hover:scale-105 transition-all duration-300 ease-in-out">
                  Pitch at Hanga <i class="fa fa-chevron-right h-2 w-2" aria-hidden="true"></i>
                </button>
              </router-link>
            </div>
          </transition>
        </div>

        <!-- Right Side with Vertically Stacked Images -->
        <transition name="fade-slide-right" appear v-if="isVisible">
          <div class="w-full md:w-1/3 space-y-4 px-4 lg:mr-12 sm:mr-0">
            <img src="../assets/Hanga-24/home/inno-section-1.jpg" alt="Speaker" class="w-full h-auto" ref="image1">
            <img src="../assets/Hanga-24/home/inno-section-3.jpg" alt="Audience" class="w-full h-auto" ref="image2">
          </div>
        </transition>
      </div>

      <!-- Benefits Section -->
      <div
        class="flex flex-wrap justify-center lg:mr-4 sm:mr-0 lg:justify-between gap-y-20 gap-x-8 lg:gap-x-20 px-4 lg:px-10 mt-24 lg:mt-16">
        <div class="w-full sm:w-1/2 lg:w-1/4 fade-in space-y-4 text-center lg:text-left" ref="item1">
          <img src="../assets/1line.png" class="max-w-[150px] sm:max-w-[180px] lg:max-w-[200px] mx-auto lg:mx-0">
          <hr class="border-t border-gray-300">
          <div class="space-y-2">
            <p class="font-futura text-5xl text-navy">GET FUNDING</p>
            <p class="text-lightblue text-lg font-gramatika mt-4 text-justify">At Hanga, you will secure
              the essential funding you need
              to elevate your startup and turn your innovative ideas into reality.</p>
          </div>
        </div>

        <div class="w-full sm:w-1/2 lg:w-1/4 fade-in space-y-4 text-center lg:text-left" ref="item2">
          <img src="../assets/2line.png" class="max-w-[150px] sm:max-w-[180px] lg:max-w-[200px] mx-auto lg:mx-0">
          <hr class="border-t border-gray-300">
          <div class="space-y-2">
            <p class="font-futura text-5xl text-navy">NETWORK</p>
            <p class="text-lightblue text-lg font-gramatika mt-4">Join Hanga to network with industry giants,
              potential investors, and like-minded entrepreneurs for collaboration and growth</p>
          </div>
        </div>

        <div class="w-full sm:w-1/2 lg:w-1/3 fade-in space-y-4 text-center lg:text-left" ref="item3">
          <img src="../assets/3line.png" class="max-w-[150px] sm:max-w-[180px] lg:max-w-[200px] mx-auto lg:mx-0">
          <hr class="border-t border-gray-300">
          <div class="space-y-2">
            <p class="font-futura text-5xl text-navy">ACCESS MENTORS</p>
            <p class="text-lightblue text-lg font-gramatika">Tap into Hanga's mentorship pool.
              Learn from the best to
              hone your business strategies and achieve lasting success.</p>
          </div>
        </div>
      </div>

      <!-- Past Winners Section -->
      <div class="relative mt-48 lg:mt-32 2xl:mt-24">
        <div ref="observerElement2">
          <transition name="fade-slide-up" appear v-if="isVisible2">
            <div>
              <p class="text-navy font-futura text-6xl ml-12">PAST WINNERS</p>
              <select v-model="selectedYear"
                class="float-right mr-20 w-30 bg-white ring-1 ring-lightTangerine outline-none p-2 px-4">
                <option value="2025">2025</option>
                <option value="2024">2024</option>
                <option value="2023">2023</option>
                <option value="2022">2022</option>
              </select>
            </div>
          </transition>

          <div class="relative overflow-x-auto flex whitespace-nowrap scrollbar-hide mt-16 ml-0 -mb-44"
            ref="scrollContainer" style="height: 800px;" @touchstart="handleTouchStart" @touchmove="handleTouchMove">
            <div v-for="winner in filteredWinners" :key="winner.name" class="relative h-[550px] w-[400px] flex-shrink-0"
              :class="winner.class">
              <transition name="zoom" appear>
                <img :src="winner.image" class="absolute inset-0 w-full h-full object-cover object-center">
              </transition>
              <div class="absolute inset-0"
                style="background: linear-gradient(to bottom, rgba(1, 9, 48, 0.05) 0%, rgba(1, 9, 48, 0.2) 50%, rgba(1, 9, 48, 0.8) 100%);">
              </div>
              <div class="text-4xl font-futura text-white absolute inset-0 flex items-center justify-center">
                <div class="space-y-4">
                  <div class="mt-80">
                    <p class="text-center">{{ winner.startup }}</p>
                  </div>
                  <div>
                    <p class="text-white font-gramatika text-xl text-center">{{ winner.name }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Hall of Fame Section -->

      <h2 class="text-4xl md:text-6xl mt-10 text-navy font-futura mb-8 mx-4 md:mx-16">HANGA HALL OF FAME</h2>
      <div class="mt-12 sm:mt-32 bg-cover h-full"
        :style="{ backgroundImage: `url(${require('@/assets/notched.svg')})` }">
        <div class="container mx-auto mb-20 px-5 py-8 md:py-16">
          <!-- <h2 class="text-6xl md:text-5xl mt-10 text-white font-futura mb-8">HANGA HALL OF FAME</h2> -->
          <div class="slide-up space-y-8 md:space-y-10" ref="texty">
            <div class="space-y-8 md:space-y-10 mt-10 md:mt-24">
              <div class="hall-logo-grid">
                <img src="../assets/2025-startups/rebanatex.png" alt="Rebanatex" class="hall-logo">
                <img src="../assets/2025-startups/neem.png" alt="Neem" class="hall-logo">
                <img src="../assets/2025-startups/nabsil.png" alt="Nabsil" class="hall-logo">
                <img src="../assets/2025-startups/ambucycle.png" alt="Ambucycle" class="hall-logo">
                <img src="../assets/2025-startups/ingoga.png" alt="Ingoga" class="hall-logo">
              </div>
              <hr class="border-lineColor border-t-2">
            </div>

            <div class="space-y-8 md:space-y-10">
              <div class="hall-logo-grid">
                <img src="../assets/2024-startups/2024-startups/Sinc.png"
                  class="hall-logo">
                <img src="../assets/2024-startups/2024-startups/Clenville.png"
                  class="hall-logo">
                <img src="../assets/2024-startups/2024-startups/Afyawave.png"
                  class="hall-logo">
                <img src="../assets/2024-startups/2024-startups/Lifeline.png"
                  class="hall-logo">
                <img src="../assets/2024-startups/2024-startups/Geuza.png"
                  class="hall-logo">
              </div>
              <hr class="border-lineColor border-t-2">
            </div>

            <div class="space-y-8 md:space-y-10">
              <div class="hall-logo-grid">
                <img src="../assets/2023/loopa.svg" alt="Loopa" class="hall-logo">
                <img src="../assets/2023/hova.svg" alt="Hova" class="hall-logo">
                <img src="../assets/2022/umurava.svg" alt="Umurava" class="hall-logo">
                <img src="../assets/2023/medixr.svg" alt="MedixR" class="hall-logo">
                <img src="../assets/2023/dope.svg" alt="Dope" class="hall-logo">
              </div>
              <hr class="border-lineColor border-t-2">
            </div>

            <div class="space-y-8 md:space-y-10">
              <div class="hall-logo-grid">
                <img src="../assets/2022/lifesten.svg" alt="Lifesten" class="hall-logo">
                <img src="../assets/2022/paying-tone.svg" alt="Paying Tone"
                  class="hall-logo">
                <img src="../assets/2022/school-nest.svg" alt="School Nest"
                  class="hall-logo">
                <img src="../assets/2022/huza.svg" alt="Huza" class="hall-logo">
                <img src="../assets/2022/mukika.svg" alt="Mukika" class="hall-logo">
              </div>
              <hr class="border-lineColor border-t-2">
            </div>

            <div class="space-y-8 md:space-y-10">
              <div class="hall-logo-grid">
                <img src="../assets/2021/afroduino.svg" alt="Afroduino"
                  class="hall-logo">
                <img src="../assets/2021/second-life-storage.svg" alt="Second Life Storage"
                  class="hall-logo">
                <img src="../assets/2021/bag.svg" alt="Bag" class="hall-logo">
                <img src="../assets/2021/karisimbi.svg" alt="Karisimbi"
                  class="hall-logo">
                <img src="../assets/2021/hova 2.png" alt="Hova 2" class="hall-logo">
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Quotes Carousel Section -->
      <div class="ml-4 md:ml-12 mt-12 md:mt-32">
        <div class="mt-8 md:mt-12 md:ml-16 overflow-hidden relative">
          <!-- Carousel Container -->
          <div ref="quotesWrapper" class="flex transition-transform duration-500 ease-in-out">
            <!-- Quote 1 -->
            <div class="w-full flex-shrink-0 px-4">
              <div class="flex flex-col md:flex-row md:space-x-32">
                <div class="md:w-1/3 p-6">
                  <span class="font-futura text-tangerine text-5xl md:text-7xl">"</span>
                  <p class="text-navy text-2xl md:text-2xl font-gramatika font-medium -mt-6 md:-mt-8">
                    Like any other startup, we face challenges. But the exposure, network, and skills you gain through
                    Hanga Pitchfest really prepare
                    you for the next step—especially when it comes to starting your fundraising journey.
                  </p>
                  <div class="flex items-center mt-8">
                    <hr class="w-8 md:w-12 border-2 border-navy mr-2">
                    <p class="font-futura text-navy text-xl md:text-2xl">CEDRICK MUPENZI, SINC</p>
                  </div>
                </div>
                <div class="md:w-1/2 flex items-center justify-center">
                  <img src="../assets/sinc.png" class="max-h-[300px] md:max-h-[500px]">
                </div>
              </div>
            </div>

            <!-- Quote 2 -->
            <div class="w-full flex-shrink-0 px-4">
              <div class="flex flex-col md:flex-row md:space-x-32">
                <div class="md:w-1/3 p-6">
                  <span class="font-futura text-tangerine text-5xl md:text-7xl">"</span>
                  <p class="text-navy text-2xl md:text-2xl font-gramatika font-medium -mt-6 md:-mt-8">
                    One of the main challenges we had was being able to scale our production. Especially after winning
                    Hanga Pitchfest—this is
                    just a door, a small door that's propelling us to actually do it quickly. We've always had quality,
                    but now the focus is
                    on producing at scale and making it affordable for the people who need it most.
                  </p>
                  <div class="flex items-center mt-8">
                    <hr class="w-8 md:w-12 border-2 border-navy mr-2">
                    <p class="font-futura text-navy text-xl md:text-2xl">CYNTIA , LOOPA</p>
                  </div>
                </div>
                <div class="md:w-1/2 flex items-center justify-center">
                  <img src="../assets/looopaa.png" class="max-h-[300px] md:max-h-[500px]">
                </div>
              </div>
            </div>

            <!-- Quote 3 -->
            <div class="w-full flex-shrink-0 px-4">
              <div class="flex flex-col md:flex-row md:space-x-32">
                <div class="md:w-1/3 p-6">
                  <span class="font-futura text-tangerine text-5xl md:text-7xl">"</span>
                  <p class="text-navy text-2xl md:text-2xl font-gramatika font-medium -mt-6 md:-mt-8">
                    Winning Hanga Pitchfest has been a game-changer for Lifesten Health.It propelled us into the
                    spotlight and opened doors to
                    investors and esteemed clients, who were captivated by the impact that we could create together.
                  </p>
                  <div class="flex items-center mt-8">
                    <hr class="w-8 md:w-12 border-2 border-navy mr-2">
                    <p class="font-futura text-navy text-xl md:text-2xl">PEACE NDOLI, LIFESTEN HEALTH</p>
                  </div>
                </div>
                <div class="md:w-1/2 flex items-center justify-center">
                  <img src="../assets/lifestennn.png" class="max-h-[300px] md:max-h-[500px]">
                </div>
              </div>
            </div>

            <!-- Quote 4 -->
            <div class="w-full flex-shrink-0 px-4">
              <div class="flex flex-col md:flex-row">
                <div class="md:w-1/3 p-6">
                  <span class="font-futura text-tangerine text-5xl md:text-7xl">"</span>
                  <p class="text-navy text-2xl md:text-2xl font-gramatika font-medium -mt-6 md:-mt-8">
                    After Hanga Pitch Fest, we no longer work in the same way we used to. We have been enrolled in
                    different training and have since
                    improved the quality and appearance of our products. We still make lighting and Bluetooth players
                    but with high quality.
                  </p>
                  <div class="flex items-center mt-4">
                    <hr class="w-8 md:w-12 border-2 border-navy mr-2">
                    <p class="font-futura text-navy text-lg md:text-xl">DIANE CYUZUZO, AFRIDUINO</p>
                  </div>
                </div>
                <div class="md:w-1/2 flex items-center justify-center">
                  <img src="../assets/Group 41.svg" class="max-h-[300px] md:max-h-[500px]">
                </div>
              </div>
            </div>
          </div>

          <!-- Navigation Buttons -->
          <div class="flex justify-between mt-8 px-4 mt:mr-8">
            <button @click="prevQuote"
              class="border-2 rounded-full p-3 bg-white text-navy hover:bg-navy hover:text-white">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8" fill="none" viewBox="0 0 24 24"
                stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
              </svg>
            </button>
            <button @click="nextQuote"
              class="border-2 rounded-full p-3 bg-white text-navy hover:bg-navy hover:text-white mr-16">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8" fill="none" viewBox="0 0 24 24"
                stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
              </svg>
            </button>
          </div>
        </div>
      </div>

      <FilteredStarups />
      <scrollButton />
    </div>
  </div>
</template>

<script>
import scrollButton from '@/components/scrollButton.vue';
import FilteredStarups from '@/components/FilteredStarups.vue';

export default {
  name: "PitchHanga",
  components: {
    scrollButton,
    FilteredStarups
  },

  data() {
    return {
      winners: [
        { year: 2022, startup: "HUUZA", name: "Finalist", class: "bg-gray-300", image: require('../assets/2022wina/HUUZA.png') },
        { year: 2022, startup: "LIFESTEN", name: "Finalist", class: "bg-gray-100", image: require('../assets/2022wina/lifesten.png') },
        { year: 2022, startup: "MULIKA FARM", name: "Finalist", class: "bg-gray-300", image: require('../assets/2022wina/MULIKA FARM.png') },
        { year: 2022, startup: "PAYINGTONE", name: "Finalist", class: "bg-gray-100", image: require('../assets/2022wina/payingtone.png') },
        { year: 2022, startup: "SCHOOLNEST", name: "Finalist", class: "bg-gray-300", image: require('../assets/2022wina/schoolnest.png') },

        { year: 2023, startup: "LOOPA", name: "Finalist", class: "bg-gray-100", image: require('../assets/2023wina/LOOPA1.png') },
        { year: 2023, startup: "DOPE", name: "Finalist", class: "bg-gray-300", image: require('../assets/2023wina/DOPE.png') },
        { year: 2023, startup: "UMURAVA", name: "Finalist", class: "bg-gray-100", image: require('../assets/2023wina/Umurava.png') },
        { year: 2023, startup: "HOVA AI", name: "Finalist", class: "bg-gray-300", image: require('../assets/2023wina/Hova AI.png') },
        { year: 2023, startup: "MEDIXR", name: "Finalist", class: "bg-gray-100", image: require('../assets/2023wina/MediXR.png') },

        { year: 2024, startup: 'SINC TODAY', name: 'Finalist', class: "bg-gray-300", image: require('../assets/2023wina/sinc-today.jpg') },
        { year: 2024, startup: 'AFYA WAVE', name: 'Finalist', class: "bg-gray-100", image: require('../assets/2023wina/Afyawave.jpg') },
        { year: 2024, startup: 'CLENVILLE', name: 'Finalist', class: "bg-gray-300", image: require('../assets/2023wina/clenville.jpg') },
        { year: 2024, startup: 'GEUZA', name: 'Finalist', class: "bg-gray-100", image: require('../assets/2023wina/Geuza.jpg') },
        { year: 2024, startup: 'LIFELINE', name: 'Finalist', class: "bg-gray-300", image: require('../assets/2023wina/lifeline.jpg') },

        { year: 2025, startup: 'RE-BANATEX', name: 'Finalist', class: "bg-gray-300", image: require('../assets/banatex.jpg') },
        { year: 2025, startup: 'NEEM', name: 'Finalist', class: "bg-gray-100", image: require('../assets/neem.jpg') },
        { year: 2025, startup: 'NABSIL', name: 'Finalist', class: "bg-gray-300", image: require('../assets/nabsil.jpg') },
        { year: 2025, startup: 'AMBUCYCLE', name: 'Finalist', class: "bg-gray-100", image: require('../assets/ambucycle.jpg') },
        { year: 2025, startup: 'INGOGA', name: 'Finalist', class: "bg-gray-300", image: require('../assets/ingoga.jpg') },
      ],
      selectedYear: '2025',
      currentQuote: 0,
      totalQuotes: 3,
      isVisible: false,
      isVisible2: false,
    };
  },

  computed: {
    filteredWinners() {
      return this.winners.filter(winner => winner.year == this.selectedYear);
    }
  },

  mounted() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('slide-up-visible');
          entry.target.classList.add('zoom-in-visible');
          entry.target.classList.add('fade-in-visible');
        }
      })
    });

    // Observe all elements with the zoom-in class
    const elements = this.$refs;
    for (let key in elements) {
      if (elements[key]) {
        observer.observe(elements[key]);
      }
    }

    const handleMouseMove = (event) => {
      if (event.buttons) {
        this.$refs.scrollContainer.scrollLeft -= event.movementX;
      }
    };

    this.$refs.scrollContainer.addEventListener('mousemove', handleMouseMove);

    // Cleanup
    this.$refs.scrollContainer.addEventListener('mouseleave', () => {
      this.$refs.scrollContainer.removeEventListener('mousemove', handleMouseMove);
    });

    this.initiativeAnimations();
    this.blogAnimations();
  },

  methods: {
    nextQuote() {
      this.currentQuote = (this.currentQuote + 1) % this.totalQuotes;
      this.updateCarousel();
    },

    prevQuote() {
      this.currentQuote = (this.currentQuote - 1 + this.totalQuotes) % this.totalQuotes;
      this.updateCarousel();
    },

    updateCarousel() {
      const wrapper = this.$refs.quotesWrapper;
      if (wrapper) {
        wrapper.style.transform = `translateX(-${this.currentQuote * 100}%)`;
      }
    },

    handleTouchStart(event) {
      this.startX = event.touches[0].clientX;
    },

    handleTouchMove(event) {
      const distance = this.startX - event.touches[0].clientX;
      this.$refs.scrollContainer.scrollLeft += distance;
      this.startX = event.touches[0].clientX;
    },

    initiativeAnimations() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.isVisible = true;
          }
        });
      });

      observer.observe(this.$refs.observerElement);
    },

    blogAnimations() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.isVisible2 = true;
          }
        });
      }, {
        threshold: 0.5
      });

      observer.observe(this.$refs.observerElement2);
    }
  },

  beforeUnmount() {
    this.$refs.scrollContainer.removeEventListener('mousemove', this.handleMouseMove);
  }
}
</script>

<style>
.slide-up {
  transform: translateY(20px);
  opacity: 0;
  transition: all 2s ease-in-out;
}

.slide-up-visible {
  transform: translateY(0);
  opacity: 1;
}

.fade-in {
  opacity: 0;
  transition: opacity 1.2s ease-in-out;
}

.fade-in-visible {
  opacity: 1;
}

.hall-logo-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  align-items: center;
  gap: 1.75rem 1.25rem;
}

.hall-logo {
  width: 100%;
  max-width: 132px;
  height: 72px;
  object-fit: contain;
  justify-self: center;
}

@media (min-width: 640px) {
  .hall-logo-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (min-width: 768px) {
  .hall-logo-grid {
    grid-template-columns: repeat(5, minmax(0, 1fr));
    gap: 2rem;
  }

  .hall-logo {
    max-width: 150px;
    height: 96px;
  }
}

@media (min-width: 1024px) {
  .hall-logo {
    max-width: 180px;
    height: 112px;
  }
}

/* Fade and Slide Up */
.fade-slide-up-enter-active {
  transition: all 1s cubic-bezier(0.42, 0, 0.58, 1);
}

.fade-slide-up-enter-from {
  opacity: 0;
  transform: translateY(50px);
}

.fade-slide-up-enter-to {
  opacity: 1;
  transform: translateY(0);
}

/* Fade and Slide Right */
.fade-slide-right-enter-active {
  transition: all 1s cubic-bezier(0.42, 0, 0.58, 1);
}

.fade-slide-right-enter-from {
  opacity: 0;
  transform: translateX(80px);
}

.fade-slide-right-enter-to {
  opacity: 1;
  transform: translateX(0);
}

/* Zoom In */
.zoom-enter-active {
  transition: all 0.7s ease;
}

.zoom-enter-from {
  opacity: 0;
  transform: scale(0.9);
}

.zoom-enter-to {
  opacity: 1;
  transform: scale(1);
}
</style>
